import React, {useEffect, useState} from 'react'
import {BasicLayout} from '../../../modules/Layouts/basicLayout'
import CardMenu from '../../../components/CardMenu/CardMenu'
import {Link, useHistory} from 'react-router-dom'
import DarkAgregarUsuario from '../../../media/felsv/DarkAgregarUsuario.svg'
import WhiteAgregarUsuario from '../../../media/felsv/WhiteAgregarUsuario.svg'
import DarkUsuarios from '../../../media/felsv/dark_users_icon.svg'
import WhiteUsuario from '../../../media/felsv/white_users_icon.svg'
import DarkDocumentCheck from '../../../media/felsv/DarkDocumentCheck.svg'
import WhiteDocumentCheck from '../../../media/felsv/WhiteDocumentCheck.svg'
import DarkTime from '../../../media/felsv/black_time_icon.svg'
import WhiteTime from '../../../media/felsv/white_time_icon.svg'
import { KEYS } from '../../../constants/keysStorage'

const GUDashboard = () => {
  const [activo, setActivo] = useState(0)
  const history = useHistory();

  useEffect(() => {
    window.scroll(0, 0)
    let rol = localStorage.getItem(KEYS.ROL)?.toString() || '0'
    if (rol !== '2') { history.push("/home"); }
  }, [])

  return (
    <BasicLayout>
      <div className='header-link'>
        <Link to='/home' className='back-button w-inline-block'></Link>
        <h3 className='h3-titles xl'>Gestión de usuarios</h3>
      </div>
      <div className='separador'></div>
      <div className='home-grid2-columns home-dashboard'>
        <div className='home-dashboard wf-layout-layout'>
          <CardMenu
            to='/gestion-usuarios/crear-usuario'
            activar={() => setActivo(1)}
            desactivar={() => setActivo(0)}
            activo={activo === 1}
            WhiteIcon={WhiteAgregarUsuario}
            DarkIcon={DarkAgregarUsuario}
            title='Crear usuario'
            description='Es un proceso sencillo y rápido que permite a los usuarios acceder a una amplia gama de servicios y recursos en línea'
            autoFocus={true}
          />
          <CardMenu
            to='/gestion-usuarios/listar-usuarios'
            activar={() => setActivo(2)}
            desactivar={() => setActivo(0)}
            activo={activo === 2}
            WhiteIcon={WhiteUsuario}
            DarkIcon={DarkUsuarios}
            title='Lista de usuarios'
            description='Esta pantalla permite realizar el mantenimiento de todos los Usuarios del sistema. Independientemente de las funciones del usuario o de su forma de validación'
          />
        </div>
        <div className='home-dashboard wf-layout-layout'>
          <CardMenu
            to='/gestion-usuarios/estado-documentos'
            activar={() => setActivo(3)}
            desactivar={() => setActivo(0)}
            activo={activo === 3}
            WhiteIcon={WhiteDocumentCheck}
            DarkIcon={DarkDocumentCheck}
            title='Gestión de sucursales y documentos'
            description='Ayudan a evitar conflictos de datos y a aplicar el control de versiones. Determinan quién puede cambiar los documentos, cuándo se pueden cambiar los documentos y cuándo se pueden ver los cambios por otras personas.'
          />
          <CardMenu
            to='/gestion-usuarios/horarios'
            activar={() => setActivo(4)}
            desactivar={() => setActivo(0)}
            activo={activo === 4}
            WhiteIcon={WhiteTime}
            DarkIcon={DarkTime}
            title='Horarios de atención'
            description='Administra y controla los horarios de atención de las sucursales registradas. Encuentra la empresa que deseas y configura los horarios de apertura y cierre, con la opción de establecer horarios sin limitación si así lo deseas.'
          />
        </div>
      </div>
    </BasicLayout>
  )
}

export default GUDashboard
